import dayjs, { Dayjs } from 'dayjs';

export const computeDisabledData = (
  currentMoment: Dayjs,
  { from }: { from?: Dayjs },
) => {
  const current = dayjs(currentMoment);
  const startDate = from ? dayjs(from) : null;
  const endOfToday = dayjs().endOf('day');
  const maxEndOfInterval = startDate
    ?.add(7, 'day')
    .subtract(1, 'day')
    .endOf('day');
  const finalEndOfInterval = endOfToday.isBefore(maxEndOfInterval)
    ? endOfToday
    : maxEndOfInterval;
  const maxStartOfInterval = startDate?.subtract(7, 'day').endOf('day');
  if (!current) return false;

  if (!startDate) {
    return current.isAfter(endOfToday);
  }
  return (
    current &&
    (current.isAfter(finalEndOfInterval) ||
      current.isBefore(maxStartOfInterval))
  );
};

// TODO: This is a temporary fix and should be replaced
// with a more reliable implementation
export const generateRandomKey = () =>
  (Math.random() * 10000).toFixed(0).toString();
